import {GuideStep} from '@blesk-frontend/api';
import {createId} from '@paralleldrive/cuid2';
import {toMerged} from 'es-toolkit/object';

import {createStepPayload} from './createStepPayload';

/**
 * Creates a step payload.
 * @param partialStep
 * @returns
 */
export const createStep = (step: Partial<GuideStep> = {}): GuideStep => {
  const emptyStep: GuideStep = {
    id: createId(),
    payload: createStepPayload(),
    position: 0,
  };

  return toMerged(emptyStep, step);
};
